import { render, staticRenderFns } from "./tagManage.vue?vue&type=template&id=10114903&scoped=true&"
import script from "./tagManage.vue?vue&type=script&lang=js&"
export * from "./tagManage.vue?vue&type=script&lang=js&"
import style0 from "./tagManage.vue?vue&type=style&index=0&id=10114903&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10114903",
  null
  
)

export default component.exports